<template>
  <div class="contact-box" v-bind:class="{ open: isOpened }">
    <div class="info-row">
      <div
        v-on:tap="goTo('/profile?user=' + userContact.id )"
        v-bind:class="{google : userImage.indexOf('googleusercontent')!==-1|| userImage.indexOf('placeholder_img_profilo')!==-1}"
        class="contact-image contact-l"
      >
        <img class="profilo" v-bind:src="userImage" />
      </div>
      <div v-on:tap="isOpened=!isOpened" class="contact-r">
        <div class="contact-name">
          <span>{{userName}}</span>
        </div>
        <div class="icon-container">
          <IconMinus v-if="isOpened" />
          <!--<img v-if="isOpened" src="../assets/rds-life-fonticons/meno.svg" alt="minus" />-->
          <!--<img v-else src="../assets/rds-life-fonticons/add.svg" alt="plus" />-->
        </div>
      </div>

      <!-- <i class="rds-icon rds-icon-plus"></i> -->
    </div>

    <transition name="contact-details-heigth" mode="out-in">
      <div class="contact-details" v-if="isOpened">
        <a
          v-bind:href="contact.href"
          v-for="contact in userContact.contacts"
          v-bind:key="contact.id"
        >
          <div class="contact-detail">
            <div class="contact-type contact-l">
              <img class="icona" v-bind:src="contact.image" />
            </div>
            <div class="contact-r">
              <span v-html="contact.dispayValue"></span>
            </div>
          </div>
        </a>
      </div>
    </transition>
  </div>
  <!-- <div class="contact-box" v-bind:class="{ open: isOpened }">
    <div v-on:tap="isOpened=!isOpened" class="info-row">
      <img class="profilo" v-bind:src="userContact.image" />
      <div class="name-box">
        <p>{{userContact.name}}</p>
      </div>
      <img class="plus" src="../assets/images/plus.svg" />
    </div>
    <div class="show" v-if="isOpened">
      <div class="contatti" v-for="contact in userContact.contacts" v-bind:key="contact.id">
        <img class="icona" v-bind:src="contact.image" />
        <p>{{contact.label}}: {{contact.value}}</p>
      </div>
    </div>
  </div>-->
</template>
<script>
import IconMinus from '../assets/rds-life-fonticons/meno.svg?inline';
function enrichUserContact(originalUserContact) {
  let userContact = Object.assign(originalUserContact);
  for (let i = 0; i < userContact.contacts.length; i++) {
    const contact = userContact.contacts[i];
    contact.id = i;

    switch (contact.key) {
      case 'Email':
        contact.image = require('../assets/images/life_email_v1.svg');
        contact.isMobilePhone = false;
        contact.label = 'Email';
        contact.href = 'mailto:' + contact.value;
        contact.dispayValue = contact.value;
        // <a href="mailto:tua1@email.com,tua2@email.com">Manda</a>
        break;
      case 'Tel. Interno':
        contact.image = require('../assets/images/life_tel_v1.svg');
        contact.isMobilePhone = false;
        contact.label = 'Tel. Interno';
        contact.href = 'tel:+39' + contact.value;

        let intCustomInterno = contact.value.slice(-3);
        let intcustomPrefix = contact.value.slice(0, 2);
        let intcustomOtherPart = contact.value.slice(2, 7);

        contact.dispayValue =
          intcustomPrefix +
          '.' +
          intcustomOtherPart +
          '.' +
          '<b>' +
          intCustomInterno +
          '</b>';

        // <a href="tel:+390123456789">chiama +390123456789</a>
        break;
      case 'Mobile':
        contact.image = require('../assets/images/life_cel_v1.svg');
        contact.isMobilePhone = false;
        contact.label = 'Cell';
        contact.href = 'tel:+39' + contact.value;

        let mobCustomPrefix = contact.value.slice(0, 3);
        let mobCustomOtherPart = contact.value.slice(3, contact.value.length);
        contact.dispayValue = mobCustomPrefix + '.' + mobCustomOtherPart;

        break;
      default:
        contact.image = require('../assets/images/life_email_v1.svg');
        contact.isMobilePhone = false;
        contact.label = 'Email';
        contact.dispayValue = contact.value;
        break;
    }
  }
  return userContact;
}
// import HomeProfile from "@/components/HomeProfile.vue";
export default {
  name: 'rds-contact-card',
  components: { IconMinus },
  props: ['userContact'],
  computed: {
    userImage() {
      const DEFAULT_IMG =
        'https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/usersImg/default-user.jpg';
      if (this.userContact.photos[0] !== DEFAULT_IMG) {
        return this.userContact.photos[0];
      } else {
        // return require('../assets/images/img_segnaposto_home_profilo.png');
        return require('../assets/images/p_placeholder_img_profilo.svg');
      }
    },
    userName() {
      return this.userContact.name
        .replace('undefined ', '')
        .replace(' undefined', '')
        .replace('undefined', '');
    }
  },
  beforeMount() {
    this.enrichedUserContact = enrichUserContact(this.userContact);
  },
  data() {
    return {
      isOpened: false,
      enrichedUserContact: this.userContact
    };
  },
  methods: {
    goTo(route) {
      if (route.indexOf('http') === 0) {
        window.open(route, '_blank');
      } else {
        console.log('route', route);

        this.$router.push(route);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none; /* no underline */
}
.contact-box {
  margin: 0 20px 12px;
  letter-spacing: 1px;
}
.info-row {
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-radius: 5px;
  @include shadow-bottom;

  // .contact-image {
  //   img {
  //     border-radius: 50%;
  //     width: 100%;
  //   }
  // }
  .contact-image {
    width: 38px;
    max-width: none;
    overflow: hidden;
    border-radius: 50%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    img {
      height: 38px;
      max-width: none;
      position: relative;
      right: 50%;
    }
  }
  .google.contact-image {
    img {
      border-radius: 50%;
      width: 100%;
      position: inherit;
    }
  }
  .contact-name {
    flex-grow: 1;
    font-weight: 500;
    font-size: 0.95em;
  }
  // .icon-plus {
  //   color: #c7c3c3;
  // }
  .icon-container {
    width: 16px;
    display: flex;
  }
}
.contact-details {
  color: rgba(0, 0, 0, 0.6);
  a {
    color: rgba(0, 0, 0, 0.6);
  }
  background: white;
  margin-top: -5px;
  .contact-detail {
    display: flex;
    padding: 10px 0;
    margin: 0 15px;
    // border-top: #707070 solid 0.1px;

    border-top: #efefef solid 0.1px;
    // border-color: rgba(199, 195, 195, 0.8);
    // & ~ .contact-detail {
    //   padding: 20px 0;
    // }
    // .contact-type {
    //   width: 19px;
    //   margin: 0 27px 0 5px;
    // }
    span {
      font-size: 0.95em;
    }
  }
}
.contact-l {
  width: 40px;
  text-align: center;
}
.contact-r {
  display: flex;
  flex-grow: 1;
  margin-left: 20px;
  align-items: center;
}
.contact-r a {
  margin-top: 7px;
}
.icon-container svg path {
  fill: $main-blue;
}

.contact-details {
  // transition: max-height 2s;
  max-height: 110px;
}

.contact-box.open .contact-image {
  margin: 10px 0;
}

.contact-details-heigth-enter-active,
.contact-details-heigth-leave-active {
  transition: max-height 0.2s;
  max-height: 110px;
  overflow: hidden;
}
.contact-details-heigth-enter {
  max-height: 0;
}
.contact-details-heigth-leave-to {
  max-height: 0;
}
</style>
